import { Typography, Box } from "@mui/material";
import CourseDetail from "@/app/views/courses/CourseDetail";
import { logger } from "@/lib/default-logger";

interface ConfirmationProps {
  courseData: any;
}

const Confirmation: React.FC<ConfirmationProps> = ({ courseData }) => {
  logger.log(courseData);

  return (
    <Box>
      <Typography variant="h6">Onay ve Oluştur</Typography>
      <CourseDetail courseData={courseData} />
    </Box>
  );
};

export default Confirmation;
